import className from "classnames"
//import CollapsibleItem from "../elements/collapsible-item"
import { PlusCircleIcon } from "@heroicons/react/24/outline"
import { EnvelopeIcon } from "@heroicons/react/24/solid"
import { PhoneIcon } from "@heroicons/react/24/solid"
import ButtonLink from '../../elements/button-link'
import { getButtonAppearance } from '../../../utils/button'

const FrequentlyAskedQuestions = ({ data }) => {
  return (
    // <div className="container flex flex-col items-center md:flex-row gap-20 px-8 align-top mt-6">
    <section className="container py-12 sm:py-16">
      <div className="mx-auto max-w-3xl">
        <div className="relative overflow-hidden rounded-3xl border border-[#e0b15e]/30 bg-white/45 shadow-sm backdrop-blur">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(244,188,107,0.18),transparent_60%)]" />
          <div className="relative px-6 py-10 sm:px-10">

        <h2 className="text-balance text-3xl tracking-tight text-crimson sm:text-4xl">
          {data.title}
        </h2>
         {/* List of Questions and Answers */}
       <ul className="mt-8 space-y-3">
        {data.questionsAnswers.map((qna) => (
          <li key={qna.id}>
              <details className="group rounded-2xl border border-[#e0b15e]/25 bg-white/55 shadow-sm">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 rounded-2xl px-5 py-4 text-left font-extrabold text-[#3f2415] transition hover:bg-white/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#da3334]/25">
                  <span className="text-base sm:text-lg">
                    {qna.question}
                  </span>
                  <span className="shrink-0 rounded-full border border-[#e0b15e]/35 bg-white/70 p-1 text-[#603026] shadow-sm transition group-open:rotate-45">
                    <PlusCircleIcon className="h-5 w-5" />
                  </span>
                </summary>
                <div className="px-5 pb-5 pt-0">
                  <p className="text-sm sm:text-base leading-relaxed text-[#603026]">
                   {qna.answer}
                  </p>
                </div>
              </details>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#603026]">
          {data.description}
        </p>

        {/* List of contact information */}
        <ul className="mt-6 space-y-2">
          {data.contactInformation.map((contact) => (
           <li key={contact.id}>
              <div className="flex items-center gap-3 rounded-2xl border border-[#e0b15e]/25 bg-white/55 px-4 py-3 shadow-sm">
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#da3334] shadow-sm">
                    
                  {contact.contactType === "email" ? (
                    <EnvelopeIcon className="h-4 w-4 text-white" />
                  ) : contact.contactType === "telephone" ? (
                     <PlusCircleIcon className="h-4 w-4 text-white" />
                  ) : (
                     <PlusCircleIcon className="h-4 w-4 text-white" />
                  )}
                </div>
                <div className="text-sm sm:text-base font-semibold text-[#3f2415]">
                  {contact.info}
                </div>
              </div>
            </li>
          ))}
        </ul>
        
      </div>
      </div>
      </div>
      </section>
  )
}

export default FrequentlyAskedQuestions